import _Object$fromEntries from "@babel/runtime-corejs3/core-js/object/from-entries";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import PropTypes from "prop-types";
export var plural = function plural(term) {
  if (typeof term === 'string') {
    return term;
  }
  var value = term.plural;
  if (!value) {
    throw new Error('Expected term to have a plural variation. Use a string or an object with a property named `plural`');
  }
  return value;
};
export var singular = function singular(term) {
  if (typeof term === 'string') {
    return term;
  }
  var value = term.singular;
  if (!value) {
    throw new Error('Expected term to have a singular variation. Use a string or an object with a property named `singular`');
  }
  return value;
};
export var humanTermType = function humanTermType(keys) {
  return PropTypes.shape(_Object$fromEntries(_mapInstanceProperty(keys).call(keys, function (key) {
    return [key, PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
      singular: PropTypes.string,
      plural: PropTypes.string
    })])];
  })));
};